import { createSelector } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { State } from './reducer';
import { selectGetProjectByIdState } from '../selectors';

export const getData = createSelector(selectGetProjectByIdState, (state: State) => state.data);

export const getError = createSelector(selectGetProjectByIdState, (state: State) => state.error);

export const getLoading = createSelector(selectGetProjectByIdState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomeProject) => T) =>
  createSelector(selectGetProjectByIdState, (state: State) => fn(state.data));
